<template>
	<div class="section__wrapper con-1060">
		<h3 class="section__title">{{ title }}</h3>
		<p class="section__description">{{ description }}</p>
		<div class="section" :class="{ extended: isExtendable && extend }" ref="section">
			<div class="section__text" :class="{ extendable: isExtendable }" v-html="text" ref="sectionText"></div>
			<div class="section__checkbox" v-if="!hasSecond">
				<CalcElem
					:name="prop"
					:disabled="isExtendable && !hasFirstClick"
					:options="{
						label: label,
						type: 'checkbox',
						wrapperClass: 'col-w100-chbox chbox_style-wrapper',
						className: 'mw-500px',
						group: 'statements',
						insurer: insurer,
						prop: prop,
					}"
					type="contracting"
					class="checkbox-center"
					@click="handleClick()"
				/>
			</div>
			<div class="section__checkbox" v-else>
				<CalcElem
					:name="prop"
					:disabled="isExtendable && !hasFirstClick"
					:options="{
						hasLabel: false,
						label: label,
						type: 'chooser',
						wrapperClass: 'col-w100-chbox chbox_style-wrapper',
						className: 'mw-500px',
						group: 'statements',
						insurer: insurer,
						prop: prop,
						choices: {
							true: 'Nyilatkozom a kármentességről',
							false: 'Történt káresemény',
						},
					}"
					type="contracting"
					class="checkbox-center"
					@click="handleClick()"
				/>
			</div>
			<div class="section__extend" v-if="isExtendable" @click="handleExtend">
				Részletek
				<span>{{ !extend ? '⌄' : '⌃' }}</span>
			</div>
		</div>
		<div class="section__input" v-if="input !== undefined && input.show && input.for === prop">
			<ValidationProvider
				:vid="input.prop"
				:name="input.placeholder"
				rules="required"
				v-slot="{ errors, classes }"
				slim
			>
				<textarea
					v-model="computedVModel"
					:name="input.prop"
					cols="30"
					rows="10"
					:placeholder="input.placeholder"
					:class="classes"
				></textarea>
				<span :class="['error_message error_message--broke']">{{ errors[0] }}</span>
			</ValidationProvider>
		</div>
	</div>
</template>

<script>
import _ from 'lodash';
import { mapGetters, mapMutations } from 'vuex';

export default {
	props: {
		title: { type: String, default: null },
		description: { type: String, default: null },
		text: { type: String, default: null },
		prop: { type: String, default: null },
		insurer: { type: String, default: null },
		label: { type: String, default: 'Elolvastam és hozzájárulok' },
		secondLabel: { type: String, default: null },
		input: { type: Object, default: () => {} },
	},
	mounted() {
		this.allSection = this.$parent.$refs;
		this.height = this.$refs.sectionText.offsetHeight ?? null;
		//this.isExtendable = this.height > 72;
		this.isExtendable = false;
	},
	data() {
		return {
			allSection: null,
			height: null,
			isExtendable: false,
			extend: false,
			hasFirstClick: false,
			secondValue: false,
		};
	},
	computed: {
		...mapGetters('contracting', ['getDamageEvent']),
		hasSecond() {
			return this.secondLabel !== null;
		},
		computedVModel: {
			get() {
				return this.getDamageEvent;
			},
			set(value) {
				this.setDamageEvent(value);
			},
		},
	},
	methods: {
		...mapMutations('contracting', ['setDamageEvent']),
		handleClick() {
			if (!this.hasFirstClick && this.isExtendable) {
				this.extend = true;
				this.hasFirstClick = true;
				this.closeOtherSections();
			}
		},
		handleExtend() {
			this.extend = !this.extend;
			this.hasFirstClick = true;
			this.closeOtherSections();
		},
		closeOtherSections() {
			_.each(this.allSection, section => {
				if (section[0].$refs.section !== this.$refs.section) {
					section[0].extend = false;
				}
			});
		},
	},
};
</script>
